/**
 * FORMATEA EL NÚMERO PARA SER MAS LEÍBLE POR COMAS
 * @param {Number} numero 
 * @returns STRING DE LA CIFRA
 */
const formatearNumero = numero => {
    let [entero, decimal] = String(numero).split(".");
    entero = entero.split("");

    let index = 3;
    let digitosRestantes = entero.length;

    while (true) {
        if (digitosRestantes <= 3) break;
        else {
            entero.splice(entero.length - index, 0, ",");
            digitosRestantes -= 3;
            index += 4;
        }
    }

    return (`${entero.join("")}.${decimal}`);
}

export default formatearNumero;